export const GetCreatedAtDate = (createdAt: string) => {
    const dateObj = new Date(createdAt.replace(" ", "T"));
    return dateObj.toISOString().split("T")[0];
}

export const GroupDate = (dateStr: string) => {
    const [year, month, day] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    const parts = new Intl.DateTimeFormat('en', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    }).formatToParts(date);

    const dayPart = parts.find(p => p.type === 'day')?.value;
    const monthPart = parts.find(p => p.type === 'month')?.value;
    const yearPart = parts.find(p => p.type === 'year')?.value;

    return `${dayPart} ${monthPart} ${yearPart}`;
}

export const GetRelativeDate = (createdAt: string) => {
    const date = new Date(createdAt);
    const now = new Date();

    const today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
    );

    const target = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
    );

    const diffMs = today.getTime() - target.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    if (diffDays === 0) {
        return 'Today';
    }

    if (diffDays === 1) {
        return 'Yesterday';
    }

    return date.toLocaleDateString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit'
    });
}